export default "__VITE_ASSET__BoSlK6IF__"